export type ForegroundRetryAction = {
  kind: "retry";
  label: "Retry";
  run: () => void | Promise<void>;
};

type ForegroundRetrySnapshot = ForegroundRetryAction | null;

let snapshot: ForegroundRetrySnapshot = null;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => listener());
}

export function setForegroundRetryAction(action: ForegroundRetrySnapshot) {
  snapshot = action;
  emit();
}

export function clearForegroundRetryAction() {
  if (snapshot == null) return;
  snapshot = null;
  emit();
}

export function getForegroundRetrySnapshot() {
  return snapshot;
}

export function subscribeForegroundRetry(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
